import { render, staticRenderFns } from "./NewsTypes.vue?vue&type=template&id=3c9a91c5&scoped=true"
import script from "./NewsTypes.vue?vue&type=script&lang=js"
export * from "./NewsTypes.vue?vue&type=script&lang=js"
import style0 from "./NewsTypes.vue?vue&type=style&index=0&id=3c9a91c5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9a91c5",
  null
  
)

export default component.exports